import { userLoginDataStorage } from '@/storages/userLoginDataStorage';
import { EventSourcePolyfill } from 'event-source-polyfill';

class Mercure 
{
    url = null;

    constructor(url) {
        this.url = url;
    }

    createMercureEvent(topic)
    {
        const url = new URL(this.url);
        url.searchParams.append('topic', topic);

        return this.mercureEvent = new EventSourcePolyfill(url, {
            headers: {
                Authorization: this.getUserMercureToken()
            }
        });
    }

    getUserMercureToken() {
        const userLoginDataStorageInstance = userLoginDataStorage();
        return userLoginDataStorageInstance.getUserMercureToken();
    }
}

const mercureInstance = new Mercure(process.env.VUE_APP_MERCURE_URL);

export default {
    install(app) {
        app.config.globalProperties.$mercure = mercureInstance;
    }
};